// enum ETriggerEventType {
// 	NotificationTimeout = 'NotificationTimeout',
// 	CycleStatus = 'CycleStatus',
// 	StationStatus = 'StationStatus',
// 	ClientEvent = 'ClientEvent',
// }
// export const TriggerEventType = EnumExt(ETriggerEventType);
/*** Trigger event type*/
// export type TriggerEventType = EnumType<typeof TriggerEventType>;

export const TriggerEventType = {
	NotificationTimeout: 'NotificationTimeout',
	CycleStatus: 'CycleStatus',
	StationStatus: 'StationStatus',
	ClientEvent: 'ClientEvent',
} as const;
export type TriggerEventType = (typeof TriggerEventType)[keyof typeof TriggerEventType];
